import React from 'react';

const mergeHighlightRanges = (ranges) => {
    if (!ranges || ranges.length === 0) return [];
    return ranges
        .filter((range) => range.start <= range.end)
        .sort((a, b) => a.start - b.start)
        .reduce((merged, current) => {
            const last = merged[merged.length - 1];
            if (last && current.start <= last.end) {
                last.end = Math.max(last.end, current.end);
            } else {
                merged.push(current);
            }
            return merged;
        }, []);
};

const highlight = (text, highlights) => {
    if (!text) return React.createElement('span', null, text);
    const parts = [];
    let lastIndex = 0;

    highlights.forEach(({ start, end }, index) => {
        if (lastIndex < start) {
            parts.push(text.substring(lastIndex, start));
        }
        parts.push(
            React.createElement(
                'span',
                { key: index, className: 'text-theme1-brightRed font-bold' },
                text.substring(start, end)
            )
        );
        lastIndex = end;
    });

    if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex));
    }

    return React.createElement('span', null, ...parts);
};

export const renderFieldWithHighlighting = (value, field, matchedFields, index = null) => {
    const fieldKey = index !== null ? `${field}.${index}` : field;
    const keywordFieldKey = index !== null ? `${field}.keyword.${index}` : `${field}.keyword`;

    if (matchedFields) {
        let mergedHighlights = [];
        if (fieldKey in matchedFields) {
            mergedHighlights = mergeHighlightRanges(matchedFields[fieldKey]);
        }
        if (keywordFieldKey in matchedFields) {
            const keywordHighlights = mergeHighlightRanges(matchedFields[keywordFieldKey]);
            mergedHighlights = [...mergedHighlights, ...keywordHighlights];
        }
        return highlight(value, mergedHighlights);
    }

    return value;
};

export const highlightFileContent = (search, content) => {
    const maxLength = 40;

    if (!content) return content;

    let parts = [];
    let lastEnd = 0;
    let matchStart = 0;

    while ((matchStart = content.toLowerCase().indexOf(search.toLowerCase(), matchStart)) !== -1) {
        const matchEnd = matchStart + search.length;

        const before = content.slice(Math.max(0, matchStart - maxLength), matchStart);
        const after = content.slice(matchEnd, matchEnd + maxLength);

        if (lastEnd < matchStart) {
            parts.push(React.createElement('br', { key: matchStart + 'before' }));
            parts.push('...');
        }

        if (before) {
            parts.push(before);
        }

        parts.push(
            React.createElement(
                'span',
                { key: matchStart, className: 'text-theme1-brightRed font-bold' },
                content.slice(matchStart, matchEnd)
            )
        );

        if (after) {
            parts.push(after);
        }

        matchStart = matchEnd;
        lastEnd = matchEnd;
    }

    if (lastEnd < content.length) {
        parts.push(React.createElement('br', { key: 'after' }));
        parts.push('...');
    }

    return React.createElement('span', null, ...parts);
};
